import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-log-timestamp-actor',
  templateUrl: './log-timestamp-actor.component.html',
  styleUrls: ['./log-timestamp-actor.component.scss'],
})
export class LogTimestampActorComponent {
  @Input() userId: string | null;
  @Input() displayName: string | null;
  @Input() systemName: string | null;
  @Input() timestamp: Date | string;
}
